'use client';

import { useTranslations } from 'next-intl';
import { Zap, LayoutGrid, Paintbrush, DoorOpen, Users, Star, ShieldCheck } from 'lucide-react';
import { NavBar } from '@/components/ui/NavBar';

// Client wrapper: builds the nav items (icons are components, so they can't be
// passed from the server-rendered page) using the existing `nav` translations
// and the site's section anchors.
export function SiteNavBar() {
  const t = useTranslations('nav');

  const items = [
    { name: t('electrical'), url: '#instalacje', icon: Zap },
    { name: t('tile'), url: '#plytki', icon: LayoutGrid },
    { name: t('painting'), url: '#malowanie', icon: Paintbrush },
    { name: t('floors'), url: '#podlogi-drzwi', icon: DoorOpen },
    { name: t('about'), url: '#o-nas', icon: Users },
    { name: t('clients'), url: '#opinie', icon: Star },
    { name: t('guarantees'), url: '#gwarancje', icon: ShieldCheck },
  ];

  return <NavBar items={items} />;
}
